import { DATE_TIME_FORMAT } from "../../../../constants";
import { Typography } from "antd";
import { FormatDate } from "../../../../constants";

const { Title } = Typography;

interface PaymentFailedFormProps {
    amount: number;
    reason: string;
    errorMessage: string;
    errorOccurredAt: Date;
}

export const PaymentFailedForm: React.FC<PaymentFailedFormProps> = (props) => {
    return (
        <div
        style={{
          backgroundColor: "white",
          paddingTop: "20px",
          paddingBottom: "20px",
          paddingLeft: "20px",
          paddingRight: "20px",
          margin: 10,
          textAlign: "left",
          border: "1px solid #d9d9d9",
          borderRadius: "8px",
        }}
      >
        <Title level={5}>Something went wrong</Title>
        <div>
            The request of US${props.amount} for {props.reason} failed due to the following error:
            <div
            className="shadow-sm"
            style={{
                margin: "10px 5px",
                padding: "10px",
                color: "black",
                borderRadius: "8px",
                background: "#F8D7DA",
                overflow: "auto",
            }}
            >
                <strong>US${props.amount} Payment Processing Error</strong>
                <br/>
                <span style={{ color: "red" }}>
                    {props.errorMessage}
                </span>
                <br/>
                {FormatDate(props.errorOccurredAt, DATE_TIME_FORMAT).toString()}
            </div>
        </div>
    </div>
    )
}